import React, { useState } from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiCalendar } from "react-icons/fi";
import Chart from "react-apexcharts";


const DashboardCharts = () => {

  /* tooltip state */

  const [tooltip, setTooltip] = useState(null);

  const showTooltip = (type, value, x, y, color) => {
    setTooltip({ type, value, x, y, color });
  };

  const hideTooltip = () => setTooltip(null);

  /* leave chart */

  const leaveChart = {
    series: [45, 68, 12],
    options: {
      chart: {
        type: "radialBar",
        height: 220
      },
      colors: ["#ff6b1a", "#ff9b6a", "#ffc5a6"],
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            size: "40%"
          },
          track: {
            background: "#eee"
          },
          dataLabels: {
            show: false
          }
        }
      },
      labels: ["Sick Leave", "Casual Leave", "Unpaid"]
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
<Col>
      {/* Employee Status */}

      <Card className="flex-fill mb-3 shadow-sm">
        <Card.Body>

          <div className="border rounded d-flex align-items-center justify-content-between p-2 mb-3 status-header">
            <h5 className="mb-0 fw-semibold">
              Employee Status & Type
            </h5>

            <Link to="/employee-report" className="btn btn-light btn-sm border">
              View All
            </Link>
          </div>

          {/* striped chart */}

          <div className="status-chart mb-3">

            <div
              className="bar fulltime"
              onMouseMove={(e) =>
                showTooltip("Full Time", 1054, e.clientX, e.clientY, "#ff6b1a")
              }
              onMouseLeave={hideTooltip}
            ></div>

            <div
              className="bar contract"
              onMouseMove={(e) =>
                showTooltip("Contract", 568, e.clientX, e.clientY, "#174f5f")
              }
              onMouseLeave={hideTooltip}
            ></div>

            <div
              className="bar probation"
              onMouseMove={(e) =>
                showTooltip("Probation", 80, e.clientX, e.clientY, "#e5e5e5")
              }
              onMouseLeave={hideTooltip}
            ></div>

          </div>

          {/* tooltip */}

          {tooltip && (
            <div
              className="chart-tooltip"
              style={{
                top: tooltip.y + 10,
                left: tooltip.x - 80
              }}
            >
              <div className="tooltip-header">
                Total
              </div>

              <div className="tooltip-body">
                <span
                  className="tooltip-dot"
                  style={{ background: tooltip.color }}
                ></span>

                {tooltip.type}: <b>{tooltip.value}</b>
              </div>
            </div>
          )}

          {/* numbers */}

          <Row className="text-center">

            <Col>
              <h3 className="fw-bold">1054</h3>
              <p className="mb-0 d-flex justify-content-center align-items-center">
                <span className="legend fulltime me-2"></span>
                Full-Time
              </p>
            </Col>

            <Col>
              <h3 className="fw-bold">568</h3>
              <p className="mb-0 d-flex justify-content-center align-items-center">
                <span className="legend contract me-2"></span>
                Contract
              </p>
            </Col>

            <Col>
              <h3 className="fw-bold">80</h3>
              <p className="mb-0 d-flex justify-content-center align-items-center">
                <span className="legend probation me-2"></span>
                Probation
              </p>
            </Col>

          </Row>

        </Card.Body>
      </Card>

      {/* Leave Distribution */}

      <Card className="flex-fill shadow-sm">
        <Card.Body>

          <div className="border rounded d-flex align-items-center justify-content-between p-2 mb-3 status-header">

            <h5 className="mb-0 fw-semibold">
              Leave Type Distribution
            </h5>

            <Dropdown>
              <Dropdown.Toggle className="border btn-light d-flex align-items-center no-arrow">
                <FiCalendar className="me-1"/>
                Monthly
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Monthly</Dropdown.Item>
                <Dropdown.Item>Weekly</Dropdown.Item>
                <Dropdown.Item>Today</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>

          <Row>

            <Col sm={5}>
              <Chart
                options={leaveChart.options}
                series={leaveChart.series}
                type="radialBar"
                height={200}
              />
            </Col>

            <Col sm={7} className="mt-3 mt-sm-0">

              <div className="d-flex justify-content-between mb-2">
                <p className="mb-0">
                  <span className="dot sick"></span> Sick Leave
                </p>

                <span className="badge bg-light border text-dark rounded-pill">
                  45
                </span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <p className="mb-0">
                  <span className="dot casual"></span> Casual Leave
                </p>

                <span className="badge bg-light border text-dark rounded-pill">
                  68
                </span>
              </div>

              <div className="d-flex justify-content-between">
                <p className="mb-0">
                  <span className="dot unpaid"></span> Unpaid
                </p>

                <span className="badge bg-light border text-dark rounded-pill">
                  12
                </span>
              </div>

            </Col>

          </Row>

        </Card.Body>
      </Card>
<style>
     {
          `
          .status-header{
border-left:3px solid #ff6b1a;
}

/* striped chart */

.status-chart{
display:flex;
height:50px;
width:100%;
overflow:hidden;
border-radius:4px;
}

.bar{
height:100%;
background-size:8px 8px;
background-image: repeating-linear-gradient(
90deg,
transparent,
transparent 3px,
currentColor 3px,
currentColor 5px
);
cursor:pointer;
}

.fulltime{
color:#ff6b1a;
width:60%;
}

.contract{
color:#174f5f;
width:35%;
}

.probation{
color:#e5e5e5;
width:5%;
}

/* legends */

.legend{
width:6px;
height:20px;
border-radius:2px;
display:inline-block;
}

.legend.fulltime{
background:#ff6b1a;
}

.legend.contract{
background:#174f5f;
}

.legend.probation{
background:#e5e5e5;
}

/* tooltip */

.chart-tooltip{
position:fixed;
background:white;
border-radius:8px;
box-shadow:0 4px 12px rgba(0,0,0,0.15);
width:160px;
z-index:999;
font-size:14px;
}

.tooltip-header{
background:#f1f1f1;
padding:8px 12px;
border-radius:8px 8px 0 0;
color:#6c757d;
}

.tooltip-body{
padding:10px 12px;
display:flex;
align-items:center;
gap:6px;
}

.tooltip-dot{
width:10px;
height:10px;
border-radius:50%;
}

/* leave dots */

.dot{
width:8px;
height:8px;
border-radius:50%;
display:inline-block;
margin-right:6px;
}

.sick{background:#ff6b1a;}
.casual{background:#ff9b6a;}
.unpaid{background:#ffc5a6;}

.no-arrow::after{
display:none!important;
}
          
          `
     }
</style>
    </Col>
    </div>
  );
};

export default DashboardCharts;